// import { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateSelect = ({
  value,
  label,
  name,
  onChange,
  className,
  labelClassName,
  inputClassName,
}) => {
  const handleChange = (newVal) => {
    onChange({ name, value: newVal });
  };
  return (
    <div className={className}>
      {label && <p className={labelClassName}>{label}</p>}
      <DatePicker
        name={name}
        value={value}
        selected={value ? value.seconds * 1000 : new Date()}
        onChange={handleChange}
        wrapperClassName="custom-datepicker"
        className={inputClassName || ''}
      />
    </div>
  );
};
export default DateSelect;
